import $ from 'jquery'

import * as Model from 'api/model'
import * as PoziUtils from 'api/utils'

export default function () {
  const app = PoziUtils.getApp()

  const bFollowMode = Model.get('app.gps.follow', false)

  if (bFollowMode) {
    console.log('Turn off follow mode.')
    Model.set('app.gps.follow', false)
    app.geolocation.setTracking(false)
    $(app.geolocateMarker.getElement()).addClass('hidden')
    $('#gpsButtonImage').attr('src', './img/the-noun-project/white/noun_800054.svg')
  } else {
    console.log('Geolocation follow control not enabled. Turn on follow mode.')
    app.geolocation.setTracking(true) // One time set... reset in onchange if track button not pressed.
    $('#gpsFollowButton').show()
    console.log('Show the follow button for 10 seconds, then fade out.')
    window.setTimeout(function () {
      $('#gpsFollowButton').fadeOut()
    }, 10000)
  }
}
